/**
 * @ngdoc Service
 */
(function () {
    'use strict';

    angular.module('vrm.components').service('TablePaginateService', TablePaginateService);
    angular.module('vrm.components').service('AdminTableService', AdminTableService);

    /**
     * @constructor
     * @ngInject
     */
    function TablePaginateService($location, NgTableParams, $rootScope, $q) {
        const service = {
            state: {
                dataFetcher: null,
                options: {
                    count: null,
                },
                isLoading: false,
                dataPromise: null,
                params: null,
                noData: false,
                initialFetchComplete: false,
            },
            setup: setup,
            getParams: getParams,
        }

        function setup(dataFetcher, { count = 100 } = {}) {
            service.state.dataFetcher = dataFetcher;
            service.state.options.count = count;
            service.state.params = getParams();

            return service.state;
        }

        function getParams() {
            return new NgTableParams(
                angular.extend({ page: 1, count: service.state.options.count }, $location.search()),
                {
                    counts: [],
                    filterOptions: {
                        filterDelay: 1
                    },
                    getData: function (params) {
                        if (service.state.dataPromise) {
                            service.state.dataPromise.reject();
                        }
                        service.state.dataPromise = $q.defer();
                        service.state.isLoading = true;
                        service.state.noData = false;
                        // Preserve the query parameter
                        const queryParam = $location.search().query;
                        const newParams = params.url();
                        if (queryParam) {
                            newParams.query = queryParam;
                        }
                        $location.replace().search(newParams);
                        const page = params.page();
                        const count = params.count();

                        service.state.dataFetcher(page, count)
                            .then(function (response) {
                                // If no data is returned, and we are on page 1, then we have no data
                                if ((page === 1 && count > 0 && !response.data.records) || response.data.num_records === 0) {
                                    service.state.noData = true;
                                    service.state.dataPromise.resolve([]);
                                    return;
                                }
                                params.total(response.data.num_records);
                                service.state.dataPromise.resolve(response.data.records ? response.data.records : []);
                                service.state.initialFetchComplete = true;
                            }, function () {
                                service.state.dataPromise.reject("Error fetching table data");
                            })
                            .finally(function () {
                                service.state.isLoading = false
                            });
                        return service.state.dataPromise.promise;
                    }
                }
            );
        }

        // Check for state changes, and update data if back / forward button is pressed
        $rootScope.$on('$locationChangeSuccess', function () {
            if (
                !angular.equals($location.search(), service.state.params.url()) &&
                !angular.equals({}, $location.search()) &&
                service.state.initialFetchComplete
            ) {
                service.state.params = getParams();
            }
        });

        return service;
    }

    /**
     * @constructor
     * @ngInject
     */
    function AdminTableService($location, NgTableParams, ApiService, $rootScope, $q, $timeout) {
        return function (endPoint, scope) {
            var self = this;
            this.filterTimeout = null;
            this.dataPromise = null;
            this.getParams = function (override) {
                override = override === undefined ? {} : override;
                return new NgTableParams(
                    angular.extend({ count: 100 }, angular.extend($location.search(), override)),  // URL based state
                    {
                        counts: [],
                        filterOptions: {
                            filterDelay: 1
                        },
                        getData: function (params) {
                            if (self.dataPromise) {
                                self.dataPromise.reject();
                            }
                            self.dataPromise = $q.defer();
                            $timeout.cancel(self.filterTimeout);
                            self.state.isLoading = true;
                            // Preserve the query parameter
                            const queryParam = $location.search().query;
                            const newParams = params.url();
                            if (queryParam) {
                                newParams.query = queryParam;
                            }
                            $location.replace().search(newParams);
                            self.filterTimeout = $timeout(function () {
                                self.state.isLoading = true;
                                // in our case we call the endpoint function from devices
                                if (scope) {
                                    var dataLoader = (typeof endPoint == "string" ? ApiService.admin(endPoint, params.url()) : endPoint(params.url(), scope.signal));
                                }
                                else {
                                    //so no errors thrown
                                    var dataLoader = (typeof endPoint == "string" ? ApiService.admin(endPoint, params.url()) : endPoint(params.url(), null));
                                }
                                dataLoader.then(function (response) {
                                    var data = response.data;
                                    // Set totals
                                    params.total(data.num_records);
                                    // Update state
                                    angular.extend(self.state, {
                                        isLoading: false,
                                        total: data.num_records,
                                        fetchedData: true
                                    });
                                    if (typeof data.num_active !== "undefined") {
                                        angular.extend(self.state, {
                                            total_active: data.num_active,
                                        })
                                    }
                                    self.dataPromise.resolve(data.records);
                                }, function () {
                                    self.dataPromise.reject();
                                });
                            }, 500);
                            return self.dataPromise.promise;
                        }
                    }
                );

            };

            this.params = self.getParams();
            // Check for state changes, and update data if back / forward button is pressed
            $rootScope.$on('$locationChangeSuccess', function () {
                if (
                    !angular.equals($location.search(), self.params.url()) &&
                    !angular.equals({}, $location.search()) &&
                    self.state.fetchedData
                ) {
                    self.params = self.getParams();
                }
            });

            this.state = {
                fetchedData: false,
                total: 0,
                total_active: 0,
                isLoading: true
            };
            return this;
        };


    }
})();
